import { Link, Route, Routes, useLocation } from "react-router-dom";
import { AppHeader } from "./components/AppHeader.js";
import { AccountPage } from "./routes/AccountPage.js";
import { GroupPage } from "./routes/GroupPage.js";
import { HistoryPage } from "./routes/HistoryPage.js";
import { HomePage } from "./routes/HomePage.js";
import { LoginPage } from "./routes/LoginPage.js";
import { NotFoundPage } from "./routes/NotFoundPage.js";
import { PrivacyPage } from "./routes/PrivacyPage.js";
import { TermsPage } from "./routes/TermsPage.js";

export function App() {
  // トップページだけは、PC で「説明 + 作成フォーム」を横並びにするため広く使う
  const isHome = useLocation().pathname === "/";

  return (
    <div className={`app${isHome ? " app--wide" : ""}`}>
      <AppHeader />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/g/:shareToken/*" element={<GroupPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <footer className="app-footer">
        <p>スプリ (Spli) — かゆいところに手が届く割り勘計算アプリ。</p>
        {/* 規約とポリシーは、どの画面からでも 1 タップで開けるようにする */}
        <nav className="app-footer__links" aria-label="規約">
          <Link to="/terms">利用規約</Link>
          <Link to="/privacy">プライバシーポリシー</Link>
        </nav>
      </footer>
    </div>
  );
}
